import { render, staticRenderFns } from "./CategoryCustom.vue?vue&type=template&id=308d1071&scoped=true"
import script from "./CategoryCustom.vue?vue&type=script&lang=js"
export * from "./CategoryCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d1071",
  null
  
)

export default component.exports